export default __webpack_public_path__ + "static/2-7b6c71f953648025f3759c0e411fd20b.png";